import { Component, Input } from '@angular/core';
import { FormInput } from '@shared/models/form-input';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-form-input-checkbox',
    templateUrl: './form-input-checkbox.component.html',
    styleUrls: ['./form-input-checkbox.component.scss'],
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, TranslateModule]
})
export class FormInputCheckboxComponent {
    @Input() field!: FormInput;
    @Input() form!: UntypedFormGroup;
    @Input() disabled?: boolean;

    get Control() {
        return this.form.get(this.field.control) as UntypedFormControl;
    }
}
